import type { ReactNode } from "react";
import { Link } from "react-router-dom";

/** Pantalla final de la inscripción pública (maqueta «Inscripción lista»,
 * Eduardo 2026-10-08). Sirve para «Yo» y para «Mi hijo o hija»: en modo hijo
 * el jugador quedó en la Cuenta Familiar del correo de quien inscribe y se
 * ofrece «Inscribir a otro jugador» (conserva «Tus datos»). El pago, los
 * grupos de WhatsApp y «Qué sigue» van en medio (`children`). */
export default function FamilyDoneCard({
  playerName,
  categoriesLine,
  familyEmail,
  accountPath,
  onRegisterAnother,
  children,
}: {
  playerName: string;
  /** Línea de categorías inscritas (y torneo). */
  categoriesLine?: string | null;
  /** Solo en modo hijo: correo de la Cuenta Familiar. `undefined` = no aplica. */
  familyEmail?: string;
  /** Solo con sesión de jugador: liga a su cuenta. */
  accountPath?: string | null;
  onRegisterAnother?: () => void;
  children?: ReactNode;
}) {
  return (
    <div className="public-registration-done">
      <header className="public-registration-done__head">
        <span className="public-registration-done__chip">✓ Inscripción recibida</span>
        <h1>Recibimos la inscripción de {playerName}</h1>
        {categoriesLine ? <p className="public-registration-done__categories">{categoriesLine}</p> : null}
        {familyEmail !== undefined ? (
          <p className="muted public-registration-done__family">
            Quedó en tu cuenta familiar{familyEmail ? ` (${familyEmail})` : ""}.
          </p>
        ) : null}
      </header>
      {children}
      {onRegisterAnother || accountPath ? (
        <div className="public-registration-done__actions">
          {onRegisterAnother ? (
            <button className="button button--secondary public-registration-family-done__another" type="button" onClick={onRegisterAnother}>
              Inscribir a otro jugador
            </button>
          ) : null}
          {accountPath ? (
            <Link className="button button--ghost" to={accountPath}>Ir a mi cuenta</Link>
          ) : null}
        </div>
      ) : null}
    </div>
  );
}
